var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-tags-input',{attrs:{"tags":_vm.tags,"is-duplicate":_vm.isDuplicate,"autocomplete-items":_vm.filteredItems,"placeholder":_vm.$t('Tags')},on:{"tags-changed":newTags => _vm.tags = newTags},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})
}
var staticRenderFns = []

export { render, staticRenderFns }